// @ts-nocheck - TODO: properly type this file!

import { useEffect, useState } from 'react';
import {
  Select,
  Checkbox,
  Divider,
  Space,
  Tag,
  FormInstance,
  //Form,
} from 'antd';
import type { TeamGroup } from '@/apis/teamGroups';
import { CustomButton, CustomShipmentText } from '@/components';
import TruncateWithTooltip from '@/components/TruncateWithTooltip';
import {
  groupMatchesSearch,
  groupSelectionState,
  isGroupValue,
  groupIdFromValue,
  teamPickerSectionLabels,
  toggleGroupSelection,
  toGroupValue,
} from '@/common/utils/teamGroups';

const { Option, OptGroup } = Select;

interface NotificationFilterApplySelectorProps {
  list: Array<{
    id: number | string;
    courier_id?: number | string;
    label?: string;
    name?: string;
    courier_name?: string;
    address?: string;
  }>;
  open: boolean;
  titleText?: string;
  background?: string;
  border?: string;
  color?: string;
  handleApplyFilters: (
    selected: (string | number)[],
    isAllSelected?: boolean
  ) => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isParernt?: boolean;
  applyType?: string[];
  applyCourierId?: boolean;
  patchedArray?: Array<{ id: number | string; label?: string; name?: string }>;
  patchedIsAll?: boolean;
  form?: FormInstance;
  formName?: string;
  allApplyType?: boolean;
  resetTeams?: boolean;
  /** Team filter only: groups shown above the teams; picking one selects its teams. */
  teamGroups?: TeamGroup[];
}

const NotificationFilterApplySelector: React.FC<
  NotificationFilterApplySelectorProps
> = ({
  //  formName,
  list,
  open,
  titleText,
  background,
  border,
  color,
  handleApplyFilters,
  setOpen,
  isParernt,
  applyType,
  applyCourierId = false,
  patchedArray = [],
  patchedIsAll = false,
  //form,
  //allApplyType,
  teamGroups = [],
}) => {
  const sectionLabels = teamPickerSectionLabels();
  const [selectedOption, setSelectedOption] = useState([]);
  const [appliedOptions, setAppliedOptions] = useState([]);
  // True only when the ALL checkbox was clicked, not just every item checked.
  const [isAllClicked, setIsAllClicked] = useState(false);
  const [appliedIsAllClicked, setAppliedIsAllClicked] = useState(false);
  // const [filteredList, setFilteredList] = useState([]);
  //   const [isSearch, setIsSearch] = useState(false);

  const uniqueList =
    list?.length > 0
      ? list.filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                (applyCourierId ? t.courier_id : t.id) ===
                (applyCourierId ? item.courier_id : item.id)
            )
        )
      : [];

  const allIds = uniqueList.map((item) =>
    applyCourierId ? item.courier_id : item.id
  );

  // List can load async after ALL was already restored — keep selection in sync once it arrives.
  useEffect(() => {
    if (isAllClicked && allIds.length > 0) {
      setSelectedOption(allIds);
      if (appliedIsAllClicked) setAppliedOptions(allIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allIds.length]);

  const handleChange = (values: (string | number)[]) => {
    // A group row is never kept as a value: it toggles its teams instead.
    const groupValue = values.find(isGroupValue);
    if (groupValue) {
      const group = teamGroups.find(
        (g) => g.id === groupIdFromValue(groupValue)
      );
      const current = isAllClicked ? allIds : selectedOption;
      setSelectedOption(group ? toggleGroupSelection(group, current) : current);
      setIsAllClicked(false);
      return;
    }
    if (values.includes('ALL')) {
      if (isAllClicked) {
        setSelectedOption([]);
        setIsAllClicked(false);
      } else {
        const allIds = uniqueList?.map((item) =>
          applyCourierId ? item.courier_id : item.id
        );
        setSelectedOption(allIds);
        setIsAllClicked(true);
      }
    } else {
      setSelectedOption(values.filter((val) => val !== 'ALL'));
      setIsAllClicked(false);
    }
  };

  //  const selectedValues = Form.useWatch(formName || '', form);
  // useEffect(() => {
  //   const selected = selectedValues || [];
  //   setAppliedOptions(selected);
  //   setSelectedOption(selected);
  // }, [allApplyType,selectedValues]);

  const handleReset = () => {
    setSelectedOption([]);
    setOpen(false);
    setAppliedOptions([]);
    setIsAllClicked(false);
    setAppliedIsAllClicked(false);
    handleApplyFilters([]);
  };

  const handleDropdownVisibleChange = (visible: boolean) => {
    setSelectedOption(appliedOptions);
    setIsAllClicked(appliedIsAllClicked);
    setOpen(visible);
  };
  // const onSearch = (value: string) => {
  //   if (!value) {
  //     setIsSearch(false);
  //     setFilteredList(list);
  //     return;
  //   }
  //   setIsSearch(true);
  //   const search = value.toLowerCase();

  //   const filtered = list.filter((item) => {
  //     const name = (item.name || "").toLowerCase();
  //     const courierName = (item.courier_name || "").toLowerCase();
  //     const address = (item.address || "").toLowerCase();

  //     return name.includes(search) || courierName.includes(search) || address.includes(search);
  //   });
  //   console.log(filtered)
  //   setFilteredList(filtered);
  //   //return filtered;
  // };

  //     useEffect(() => {
  // if (patchedArray.length === 0 &&  applyType === 5)

  //     setSelectedOption([]);
  //     setAppliedOptions([]);
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, []);

  // Source of truth for restoring saved state: the real stateKey flag
  useEffect(() => {
    if (patchedArray.length === 0 && !patchedIsAll) return;

    if (patchedIsAll) {
      setIsAllClicked(true);
      setAppliedIsAllClicked(true);
      if (allIds.length > 0) {
        setSelectedOption(allIds);
        setAppliedOptions(allIds);
      }
    } else {
      setSelectedOption(patchedArray);
      setAppliedOptions(patchedArray);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patchedIsAll]);

  const handleApply = (values) => {
    setAppliedOptions(isAllClicked ? allIds : values);
    setAppliedIsAllClicked(isAllClicked);
    const toSubmit = isAllClicked ? (isParernt ? allIds : []) : values;
    handleApplyFilters(toSubmit, isAllClicked);
  };

  useEffect(() => {
    if (isParernt && applyType) {
      setSelectedOption(applyType);
      setAppliedOptions(applyType);
    }
  }, [applyType, isParernt]);

  const isAllSelected = isAllClicked;

  return (
    <>
      <Select
        mode='multiple'
        value={selectedOption}
        onChange={handleChange}
        open={open}
        onOpenChange={handleDropdownVisibleChange}
        placeholder='Select...'
        className='custom-dd-style'
        optionLabelProp='label'
        // disabled={!isParernt && allApplyType}
        filterOption={(input, option) => {
          const search = input.toLowerCase();
          if (isGroupValue(option?.value)) {
            const group = teamGroups.find(
              (g) => g.id === groupIdFromValue(option.value)
            );
            return (
              !!group &&
              groupMatchesSearch(
                group,
                input,
                (id) => uniqueList.find((i) => String(i.id) === id)?.name
              )
            );
          }
          // extract the corresponding item from the list using option.value
          const item = uniqueList.find(
            (i) => (applyCourierId ? i.courier_id : i.id) === option?.value
          );
          if (!item) return false;
          const name = (item.name || '').toLowerCase();
          const courierName = (item.courier_name || '').toLowerCase();
          const address = (item.address || '').toLowerCase();
          return (
            name.includes(search) ||
            courierName.includes(search) ||
            address.includes(search)
          );
        }}
        tagRender={({ label, value }) => {
          const onPreventMouseDown = (
            event: React.MouseEvent<HTMLSpanElement>
          ) => {
            event.preventDefault();
            event.stopPropagation();
          };
          if (appliedOptions?.length > 0 || appliedIsAllClicked) {
            if (isAllSelected) {
              if (value === allIds[0]) {
                return (
                  <Tag
                    className='notification-filter-tag'
                    closable={!isParernt}
                    onMouseDown={onPreventMouseDown}
                    onClose={handleReset}
                    style={{
                      background: background || '#fff',
                      color: color || 'rgba(94, 94, 94, 1)',
                      border: border || '1px solid #E2E2E2',
                    }}
                  >
                    <span>All</span>
                  </Tag>
                );
              }
              return null;
            }

            return (
              <Tag
                className='notification-filter-tag'
                closable={!isParernt}
                onMouseDown={onPreventMouseDown}
                onClose={() => {
                  const newSelected = selectedOption?.filter(
                    (x) => x !== value
                  );
                  setSelectedOption(newSelected);
                  setAppliedOptions(newSelected);
                  handleApplyFilters(newSelected);
                }}
                style={{
                  background: background || '#fff',
                  color: color || 'rgba(94, 94, 94, 1)',
                  border: border || '1px solid #E2E2E2',
                }}
              >
                <TruncateWithTooltip
                  text={String(label)}
                  max={25}
                  render={(t) => (
                    <span>
                      <span>{t}</span>
                    </span>
                  )}
                />
              </Tag>
            );
          }
        }}
        dropdownRender={(menu) => (
          <>
            {titleText && (
              <CustomShipmentText
                text={titleText}
                color='var(--text-secondary)'
                fontWeight={600}
                style={{ margin: '8px 26px 4px' }}
              />
            )}
            {menu}
            <Divider className='notification-divider' style={{ margin: '0' }} />
            <Space
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '8px 8px 4px',
              }}
            >
              <CustomButton
                text='Reset'
                onClick={() => handleReset()}
                width='auto'
                height='32px'
                bgColor='transparent'
                color='var(--text-primary)'
                fontSize='12px'
                fontWeight={600}
                borderRadius='0px'
                boxShadow='none'
              />
              <CustomButton
                text='Apply'
                onClick={() => handleApply(selectedOption)}
                width='62px'
                height='32px'
                bgColor='#000'
                color='#fff'
                fontSize='12px'
                fontWeight={500}
                borderRadius='8px'
                boxShadow='0px 4px 16px 0px rgba(0, 0, 0, 0.27)'
              />
            </Space>
          </>
        )}
      >
        {uniqueList.length > 0 && (
          <>
            <Option key='all' value='ALL' label='All'>
              <Checkbox
                className='notification-filter-checkbox checkbox-sm'
                checked={isAllClicked}
                // onClick={(e) => e.stopPropagation()}
              >
                All
              </Checkbox>
            </Option>

            {teamGroups.length > 0 && (
              <OptGroup key='team-groups' label={sectionLabels.groups}>
                {teamGroups.map((group) => {
                  const state = groupSelectionState(
                    group,
                    isAllClicked ? allIds : selectedOption
                  );
                  return (
                    <Option
                      key={toGroupValue(group.id)}
                      value={toGroupValue(group.id)}
                      label={group.name}
                    >
                      <Checkbox
                        className='notification-filter-checkbox checkbox-sm'
                        checked={state.checked}
                        indeterminate={state.indeterminate}
                      >
                        <TruncateWithTooltip
                          text={group.name}
                          max={25}
                          // The limit applies to the name; the count always shows.
                          render={(t) => (
                            <span>
                              <span>{`${t} (${group.team_ids.length})`}</span>
                            </span>
                          )}
                        />
                      </Checkbox>
                    </Option>
                  );
                })}
              </OptGroup>
            )}
            {teamGroups.length > 0 ? (
              <OptGroup key='teams' label={sectionLabels.teams}>
                {uniqueList.map((item) => (
                  <Option
                    key={applyCourierId ? item.courier_id : item.id}
                    value={applyCourierId ? item.courier_id : item.id}
                    label={item.label || item.name || item.courier_name}
                  >
                    <Checkbox
                      className='notification-filter-checkbox checkbox-sm'
                      checked={
                        isAllClicked ||
                        selectedOption?.includes(
                          applyCourierId ? item.courier_id : item.id
                        )
                      }
                    >
                      <TruncateWithTooltip
                        text={String(
                          item.label || item.name || item.courier_name
                        )}
                        max={25}
                        render={(t) => (
                          <span>
                            <span>{t}</span>
                          </span>
                        )}
                      />
                    </Checkbox>
                  </Option>
                ))}
              </OptGroup>
            ) : (
              uniqueList.map((item) => (
                <Option
                  key={applyCourierId ? item.courier_id : item.id}
                  value={applyCourierId ? item.courier_id : item.id}
                  label={item.label || item.name || item.courier_name}
                >
                  <Checkbox
                    className='notification-filter-checkbox checkbox-sm'
                    checked={
                      isAllClicked ||
                      selectedOption?.includes(
                        applyCourierId ? item.courier_id : item.id
                      )
                    }
                  >
                    <TruncateWithTooltip
                      text={String(
                        item.label || item.name || item.courier_name
                      )}
                      max={25}
                      render={(t) => (
                        <span>
                          <span>{t}</span>
                        </span>
                      )}
                    />
                  </Checkbox>
                </Option>
              ))
            )}
          </>
        )}
      </Select>
    </>
  );
};
export default NotificationFilterApplySelector;
